'use strict';

/**
 *
 * @name: ucpConfig
 *
 */

function UcpConfig($stateProvider, $urlRouterProvider) {

  'ngInject';

  function _resolveModuleControllers($ocLazyLoad) {

    return $ocLazyLoad.load('UcpBundle');
  }

  $stateProvider
    .state('main.ucp', {
      url: 'profile',
      abstract: true,
      templateProvider: $templateCache => $templateCache.get('ucp.index.html'),
      controller: 'UcpController',
      data: {
        access: 'member'
      },
      resolve: {
        moduleControllers: _resolveModuleControllers
      }
    })
    .state('main.ucp.accountFeed', {
      url: '/account-feed',
      templateProvider: $templateCache => $templateCache.get('ucp-account-feed.index.html'),
      controller: 'UcpAccountFeedController'
    })
    .state('main.ucp.myPlaylists', {
      url: '/my-playlists',
      templateProvider: $templateCache => $templateCache.get('ucp-my-playlists.index.html'),
      controller: 'UcpMyPlaylistsController',
    })
    .state('main.ucp.editPlaylist', {
      url: '/edit-playlist/:id',
      templateProvider: $templateCache => $templateCache.get('ucp-edit-playlist.index.html'),
      controller: 'UcpEditPlaylistController'
    })
    .state('main.ucp.myLoved', {
      url: '/my-loved',
      templateProvider: $templateCache => $templateCache.get('ucp-my-loved.index.html'),
      controller: 'UcpMyLovedController',
      resolve: {
        resolvedMyLovedPosts: function(apiPostService, $q, $rootScope, transObject) {

          var myLovedPosts = [];

          var deferred = $q.defer();

          apiPostService
            .getPost(null, 'loveCreatedAt desc', 1, 9, $rootScope.profile.id)
            .then(function(res) {

              res.data.items.forEach(function(item) {
                transObject.calendarDate(item);
                transObject.translate(item);
                transObject.trueSlug(item);
                transObject.getDuration(item);
                myLovedPosts.push(item);
              });

              deferred.resolve(myLovedPosts);
            }, function(err) {

              deferred.reject(err);
              $rootScope.errors.push(err);
            });

          return deferred.promise;
        }
      }
    })
    .state('main.ucp.recent', {
      url: '/recently-watched',
      templateProvider: $templateCache => $templateCache.get('ucp-recent.index.html'),
      controller: 'UcpRecentController',
    })

  // FOLLOWING

  .state('main.ucp.following', {
      url: '/following',
      abstract: true,
      templateProvider: $templateCache => $templateCache.get('ucp-following.index.html'),
      controller: 'UcpFollowingController',
    })
    .state('main.ucp.following.playlist', {
      url: '/playlist',
      templateProvider: $templateCache => $templateCache.get('ucp-following-playlist.index.html'),
      controller: 'UcpFollowingPlaylistController',
    })
    .state('main.ucp.following.series', {
      url: '/series',
      templateProvider: $templateCache => $templateCache.get('ucp-following-series.index.html'),
      controller: 'UcpFollowingSeriesController',
    })
    .state('main.ucp.following.categories', {
      url: '/categories',
      templateProvider: $templateCache => $templateCache.get('ucp-following-categories.index.html'),
      controller: 'UcpFollowingCategoriesController',
    })
    .state('main.ucp.following.tags', {
      url: '/topics',
      templateProvider: $templateCache => $templateCache.get('ucp-following-tags.index.html'),
      controller: 'UcpFollowingTagsController',
    })

  // COMMUNITY

  .state('main.ucp.community', {
      url: '/community',
      abstract: true,
      templateProvider: $templateCache => $templateCache.get('ucp-community.index.html'),
      controller: 'UcpCommunityController',
    })
    .state('main.ucp.community.findPeople', {
      url: '/find-people',
      templateProvider: $templateCache => $templateCache.get('ucp-community-find-people.index.html'),
      controller: 'UcpCommunityFindPeopleController',
    })
    .state('main.ucp.community.followers', {
      url: '/followers',
      templateProvider: $templateCache => $templateCache.get('ucp-community-followers.index.html'),
      controller: 'UcpCommunityFollowersController',
    })
    .state('main.ucp.community.youFollow', {
      url: '/you-follow',
      templateProvider: $templateCache => $templateCache.get('ucp-community-you-follow.index.html'),
      controller: 'UcpCommunityYouFollowController',
    })

  // MY SETTINGS

  .state('main.ucp.mySettings', {
      url: '/my-settings',
      abstract: true,
      templateProvider: $templateCache => $templateCache.get('ucp-my-settings.index.html'),
      controller: 'UcpMySettingsController',
      resolve: {
        ucpSettingsTrueUser: function($rootScope, $q, $state, $timeout, apiUserService) {

          var deferred = $q.defer();
          apiUserService
            .getUser()
            .then(function() {

              deferred.resolve('user set');
            }, function(error) {

              $timeout(function() {

                $rootScope.header.toggle({ item: 'userNav' })
              }, 500);
              $state.go('main.home');
              deferred.reject(error);
            });
          return deferred.promise;
        }
      }
    })
    .state('main.ucp.mySettings.profile', {
      url: '/profile',
      templateProvider: $templateCache => $templateCache.get('ucp-my-settings-profile.index.html'),
      controller: 'UcpMySettingsProfileController'
    })
    .state('main.ucp.mySettings.notifications', {
      url: '/notifications',
      templateProvider: $templateCache => $templateCache.get('ucp-my-settings-notifications.index.html'),
      controller: 'UcpMySettingsNotificationsController'
    })
    .state('main.ucp.mySettings.email', {
      url: '/email',
      templateProvider: $templateCache => $templateCache.get('ucp-my-settings-email.index.html'),
      controller: 'UcpMySettingsEmailController'
    })
    .state('main.ucp.mySettings.connections', {
      url: '/connections',
      templateProvider: $templateCache => $templateCache.get('ucp-my-settings-connections.index.html'),
      controller: 'UcpMySettingsConnectionsController'
    })
    .state('main.ucp.mySettings.account', {
      url: '/account',
      templateProvider: $templateCache => $templateCache.get('ucp-my-settings-account.index.html'),
      controller: 'UcpMySettingsAccountController'
    });

  $urlRouterProvider.when('/profile', '/profile/account-feed');
  $urlRouterProvider.when('/profile/my-settings', '/profile/my-settings/profile');
  $urlRouterProvider.when('/profile/following', '/profile/following/playlist');
  $urlRouterProvider.when('/profile/community', '/profile/community/find-people');
}

export default UcpConfig;



// WEBPACK FOOTER //
// ./app/pages/ucp/ucp.config.js